var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',[_c('div',{staticClass:"contract-modal"},[_c('div',{staticClass:"contract-detail",attrs:{"id":"contractDetail"}},[_c('div',{ref:"mycanvas",attrs:{"id":"mycanvas"}})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }